module.exports = __webpack_public_path__ + "img/dislike-filled.d47904ad.svg";